module.exports = __webpack_public_path__ + "img/蓝莓2.74209001.png";